<template>
  <div style="background-color: rgb(245, 245, 245);">
    <headers></headers>
    <div class="title">
      <div class="auto">首页  >  认证考试  >  个人账户信息  >  教育经历</div>
    </div>
    <div class="padding250">
      <div class="auto">
        <!--为空时-->
        <div class="null" v-if="workList.length == 0">
          <img src="../../../assets/null.jpg" alt="">
          <p class="text">暂时没有工作经历哦~</p>

          <router-link to="/addjob"><Button  icon="ios-add-circle-outline">添加工作经历</Button></router-link>
          <a href="javascript:;" v-on:click="goBack">
            <Button style="margin-left: 10px;width: 80px;background-color: #2d8cf0;border-color: #2d8cf0;">返回</Button>
          </a>
        </div>
        <!--不为空时-->
        <div class="jiaoyu clearfix" v-if="workList.length > 0">
          <div class="titles">
            工作经历
            <a href="javascript:;" v-on:click="goBack">
              <Button style="margin-left: 10px;width: 80px;background-color: #2d8cf0;border-color: #2d8cf0;" class="pull-right">返回</Button>
            </a>
            <router-link to="/addjob"><Button icon="ios-add-circle-outline" class="pull-right">添加工作经历</Button></router-link>
          </div>
          <div style="width: 100%;" class="list" v-for="item in workList">
            <div class="name">{{item.companyName}} <Button v-on:click="delWork(item)" class="pull-right">删除</Button></div>
            <ul>
              <li>
                工作年限：{{item.workingLife}} <span class="zhuanye">职位：{{item.position}}</span>
              </li>
              <li class="text">{{item.workTask}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
    <Modal
      v-model="modal1"
      title="删除工作经历提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>您确定要删除该工作经历吗？</p>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getUserWork, delWork} from "../../../http"
  import headers from '../../template/header'
  import footers from '../../template/footer'
  export default {
    name: 'job',
    props: {},
    data() {
      return {
        showOrder: 'kaoshi',
        modal1: false,
        delWorkId: '',
        workList: []
      };
    },
    methods: {
      goBack(){
        this.$router.push({
          name: 'kaoshiAccount'
        })
      },
      ok(){
        delWork({workId: this.delWorkId}).then(res => {
          if(res.code == 200){
            this.$Notice.success({
              title: '工作经历提醒',
              desc: '删除工作经历成功',
              duration: 3,
            });
            this.getUserWork()
          }
        })
      },
      cancel(){
      },
      getUserWork(){
        getUserWork().then(res => {
          this.workList = res.data.worklist
        })
      },
      delWork(v){
        this.delWorkId = v.id
        this.modal1 = true
      }
    },
    created() {
      this.getUserWork()
    },
    components: {
      headers,
      footers
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .null{
    text-align: center;
    padding: 200px 0;
    .text{
      font-size: 14px;
      color: #999;
      margin: 10px 0 60px;
    }
  }
  button{
    background-color: #B2936B;
    color: #fff;
    display: inline-block;
    width: 200px;
    height: 50px;
    text-align: center;
    border-radius: 5px;
    font-size: 18px;
  }
  .title{
    font-size: 14px;
    color: #fff;
    height: 60px;
    line-height: 60px;
    background-color: #2F261E;
    text-align: left;
  }
  .padding250 .auto{
    background-color: #fff;
    margin-top: 30px;
    .jiaoyu{
      padding: 40px;
      .titles{
        font-size: 20px;
        color: #000;
        margin-bottom: 50px;
        text-align: left;
      }
      .list{
        border-radius: 5px;
        padding: 30px;
        box-shadow: 0px 0px 10px #ececec;
        text-align: left;
        margin-bottom: 40px;
        margin-right: 50px;
        float: left;
        width: 535px;
        .name{
          font-size: 20px;
          color: #000;
          margin-bottom: 20px;
          button{
            border:1px solid #B2936B;
            color: #B2936B;
            font-size: 16px;
            background-color: #fff;
            width: 80px;
            height: 36px;
            line-height: 20px;
          }
        }
        li{
          font-size: 14px;
          color: #000;
          margin-bottom: 10px;
          .zhuanye{
            margin-left: 20px;
          }
        }
        .text{
          color: #666;
        }
        &:nth-child(2n+1){
          margin-right: 0;
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/examination/work/job.vue